import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Paper, Typography, LinearProgress, Grid, TableBody, Table, TableRow, TableCell } from '@material-ui/core';
import { QueryFilter, QUERY_FILTER_CONSULTING_PUBLISHER } from '../../../shared';

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherCategoryBestPlayersProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherCategoryBestPlayersState {
    customFilter: {
        isChart: boolean
    },
}

const CONSULTING_PUBLISHER_CATEGORY_BEST_PLAYERS = gql`
query consultingPublisherCategoryBestPlayers($customFilter:  ConsultingPublisherCustomFilter) {
    consultingPublisherCategoryBestPlayers(consultingPublisherCustomFilter: $customFilter) {
        category,
        players {
            provider,
            volume
        }
    }
}
`;

const dataFilled = (data: any) => {
    return data && data.consultingPublisherCategoryBestPlayers && !!data.consultingPublisherCategoryBestPlayers.length
}

export class ConsultingPublisherCategoryBestPlayers extends React.Component<IConsultingPublisherCategoryBestPlayersProps, IConsultingPublisherCategoryBestPlayersState> {

    constructor(props: IConsultingPublisherCategoryBestPlayersProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          }
    }
}

    public render() {
        const jsonFilter : any = {
          "customFilter": {
            "isChart": this.state.customFilter.isChart,
          }
        };

        return (
            <Query query={QUERY_FILTER_CONSULTING_PUBLISHER} notifyOnNetworkStatusChange={true}>
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => (
                <Query query={CONSULTING_PUBLISHER_CATEGORY_BEST_PLAYERS} variables={QueryFilter.getFilterConsultingPublisher(clientC, jsonFilter, [], false)}>
                {({ loading, error, data}) => {
                    return (
                        <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16}>

                            <Grid item={true} xs={12} md={12}>
                                <Grid container={true} className="publisher-sale-panel panel-grid panel-bg-area" spacing={16}>
                                <Grid item={true} xs={12} className="panel-bg" >
                                    <Typography component="h3" className="panel-head">
                                        Fornecedores Referência
                                    </Typography>
                                    {
                                        loading
                                        ?
                                        <LinearProgress />
                                        :
                                        (
                                            dataFilled(data)
                                            ?
                                            (
                                                <Grid container={true} spacing={16}>
                                                    {
                                                        data.consultingPublisherCategoryBestPlayers.map((item: any) => {
                                                            return this.rendCategory(item);
                                                        })
                                                    }
                                                </Grid>
                                            )
                                            :
                                            (
                                                <Typography variant="body2" className="comparative" component="p">
                                                    Não há informações de vendas
                                                </Typography>
                                            )
                                        )
                                    }
                                    
                                </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }}
                </Query>
                    

            )}
            </Query>
        )
    }

    private rendCategory (item:any) {

        return  (
            <Grid item={true} xs={3} sm={3} >
                <Paper className="publisher-sale-block panel-block">
                    <Typography variant="headline" className="panel-title" component="title">
                        {item.category}
                    </Typography>
                    <Table>
                        <TableBody>
                            {item.players.map((player: any) => {
                                return (
                                    <TableRow key={player.provider}>
                                        <TableCell component="th" scope="row">
                                            <span className="filter-dialog-item">{player.provider}</span>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/consulting/publisher/categoryBestPlayers/ConsultingPublisherCategoryBestPlayers.tsx